import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {License} from "../../../config";
import {FormGroup} from "@angular/forms";
import {CourseDefinitionEntityModel} from "../course-definition-entity.model";
import {CourseData} from "../course-definition.data";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    "selector": "wbo-course-definition-edit-page",
    "templateUrl": "./course-definition-edit-page.component.html",
    providers: [provideEntityModel(CourseDefinitionEntityModel)]
})
export class CourseDefinitionEditPageComponent extends AbstractEditPage {
    CourseData = CourseData;
    License = License;

    constructor(public model: CourseDefinitionEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }

    enableIfCallAway(this: void, formGroup: FormGroup, dataItem: any): boolean {
        return formGroup.get("callAway").value;
    }
}
